import React, { useContext, useEffect, useState } from "react";

import styles from "./styles/AssetInfo.module.css";
import FileIcon from "../File/file";
import TrusteeCard from "./TrusteeCard";
import CredentialField from "./CredentialField";
import { downloadFile } from "./Home";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { getAssetTypeTranslated } from "../../Utils/translationUtils";
import BenefTrusteeCard from "./benefTrusteeCard";

function AssetInfo({ onClose, asset, trustees, allAssets }) {
  const private_key = window.sessionStorage.getItem("ostreon_key");
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  const [modal, setModal] = useState(undefined);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.AssetInfo
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.AssetInfo);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const mfaType = JSON.parse(asset.credentials).mfa;

  return (
    <div
      className={styles.background}
      onClick={(e) => {
        e.stopPropagation();
        !modal && onClose();
      }}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>{asset?.asset_name}</div>
        <div className={styles.popup_scrollable}>
          <div className={styles.field_title}>
            {dublicatedcontent.dublicatedText58}
          </div>
          <div className={styles.asset_field}>
            {getAssetTypeTranslated(
              asset?.asset_type,
              undefined,
              dublicatedcontent
            )}
          </div>
          <div className={styles.field_title}>
            {dublicatedcontent.dublicatedText59}
          </div>
          <div className={`${styles.asset_field} ${styles.asset_textarea}`}>
            {asset?.description ? (
              <>{asset.description}</>
            ) : (
              content.AssetInfoText1
            )}
          </div>
          {asset?.asset_files.length > 0 && (
            <div className={styles.field_title}>{content.AssetInfoTitle3}</div>
          )}
          <div className={styles.files_row}>
            {asset?.asset_files.map((file) => {
              return (
                <FileIcon
                  deleteable={false}
                  key={file.id}
                  filename={file.name}
                  date={file.lastModified}
                  size={file.size}
                  OnClick={() => downloadFile(file.id, file.name, private_key)}
                ></FileIcon>
              );
            })}
          </div>
          {JSON.parse(asset.credentials).record_name !==
            "This assets has no credentials" &&
            JSON.parse(asset.credentials).record_name !== undefined && (
              <div>
                <div className={styles.field_title}>
                  {content.AssetInfoTitle4}
                </div>
                <div className={styles.credentials}>
                  <div className={styles.field}>
                    <div className={styles.grey_title}>
                      {dublicatedcontent.dublicatedText61}
                    </div>
                    <CredentialField
                      text={JSON.parse(asset.credentials).record_name}
                      success_text={dublicatedcontent?.text_copied}
                    />
                  </div>
                </div>
              </div>
            )}
          {JSON.parse(asset.credentials).service_name && (
            <div>
              <div className={styles.field_title}>
                {content.AssetInfoTitle4}
              </div>
              <div className={styles.credentials}>
                <div className={styles.cred_left}>
                  <div className={styles.field}>
                    <div className={styles.grey_title}>
                      {content.AssetInfoText3}
                    </div>
                    <CredentialField
                      text={JSON.parse(asset.credentials).service_name}
                      success_text={dublicatedcontent?.text_copied}
                    />
                  </div>
                  <div className={styles.field}>
                    <div className={styles.grey_title}>
                      {dublicatedcontent?.username}
                    </div>
                    <CredentialField
                      text={JSON.parse(asset.credentials).username}
                      success_text={dublicatedcontent?.text_copied}
                    />
                  </div>
                  <div className={styles.field}>
                    <div className={styles.grey_title}>2FA</div>
                    <div>{mfaType ? mfaType : "None"}</div>
                  </div>
                </div>
                <div className={styles.cred_right}>
                  <div className={styles.field}>
                    <div className={styles.grey_title}>
                      {dublicatedcontent?.password}
                    </div>
                    <CredentialField
                      text={JSON.parse(asset.credentials).password}
                      field="password"
                      success_text={dublicatedcontent?.text_copied}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {asset.trustees.length > 0 && (
            <div className={styles.advisors}>
              <div className={styles.field_title}>{content.AssetInfoText5}</div>

              <div
                className={styles.trustee_container}
                style={{
                  rowGap: "40px",
                }}
              >
                {asset.trustees.map((trustee_id) => {
                  return trustees.map((e) => {
                    if (e.user_id === trustee_id)
                      return (
                        <BenefTrusteeCard
                          assets={allAssets}
                          trustee={e}
                          setModal={setModal}
                        />
                      );
                    return null;
                  });
                })}
              </div>
            </div>
          )}
        </div>
      </div>{" "}
      {modal && <div style={{ zIndex: 6 }}>{modal}</div>}
    </div>
  );
}

export default AssetInfo;
